import type { FormEvent, ReactNode } from "react";

/** The centred card used by sign-in, sign-up, password reset and email verification. */
export function AuthCard({
  title,
  subtitle,
  onSubmit,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  onSubmit?: (e: FormEvent) => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  const body = (
    <>
      <div className="brand brand-large">
        <span className="brand-mark" aria-hidden>
          A
        </span>
        AI Courses
      </div>
      <h1>{title}</h1>
      {subtitle && <p className="muted">{subtitle}</p>}
      {children}
      {footer && <div className="auth-footer">{footer}</div>}
    </>
  );
  return (
    <main className="login">
      {onSubmit ? (
        <form className="login-card" onSubmit={onSubmit} noValidate>
          {body}
        </form>
      ) : (
        <div className="login-card">{body}</div>
      )}
    </main>
  );
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p className="form-error" role="alert">
      {message}
    </p>
  );
}

export function errorMessage(err: unknown, fallback: string): string {
  return err instanceof Error && err.message ? err.message : fallback;
}
